"use client";

import { useEffect } from "react";
import { useSceneFloatingNav } from "@/features/lomdaEditorV2/hooks";
import {
    useScenesList,
    useSelectedSceneId,
    useUiActions,
} from "@/features/lomdaEditorV2/store";

const NEXT_KEYS = new Set(["ArrowUp", "ArrowRight"]);
const PREV_KEYS = new Set(["ArrowDown", "ArrowLeft"]);

function isTypingElement(el: EventTarget | null): boolean {
    if (!el || !(el instanceof HTMLElement)) return false;
    const tag = el.tagName.toLowerCase();
    if (tag === "input" || tag === "textarea") return true;
    return el.isContentEditable;
}

export function useSceneKeyboardNav() {
    const scenes = useScenesList();
    const selectedSceneId = useSelectedSceneId();
    const { setSelectedSceneId } = useUiActions();
    const { handleNextScene, handlePreviousScene } = useSceneFloatingNav({
        scenes,
        selectedSceneId,
        setSelectedSceneId,
    });

    useEffect(() => {
        const onKeyDown = (e: KeyboardEvent) => {
            if (isTypingElement(e.target)) return;
            if (NEXT_KEYS.has(e.key)) {
                e.preventDefault();
                handlePreviousScene();
            } else if (PREV_KEYS.has(e.key)) {
                e.preventDefault();
                handleNextScene();
            }
        };
        window.addEventListener("keydown", onKeyDown);
        return () => window.removeEventListener("keydown", onKeyDown);
    }, [handleNextScene, handlePreviousScene]);
}
